export default __webpack_public_path__ + "static/media/newlogo.a14ba2ef.png";